import home from "./home";
import aboutUs from "./about-us";
import contactUs from "./contact-us";
import golfGetawaysMasthead from "./golf-getaways-masthead";
import aboutCoursesMasthead from "./about-courses-masthead";
import footer from "./footer";
import navbar from "./navbar";
import checkout from "./checkout";

// pageKey -> fallback blocks. Add an entry here alongside each new
// defaultContent/<page>.js file as later phases add more pages.
const DEFAULT_CONTENT = {
  home,
  "about-us": aboutUs,
  "contact-us": contactUs,
  "golf-getaways-masthead": golfGetawaysMasthead,
  "about-courses-masthead": aboutCoursesMasthead,
  footer,
  navbar,
  checkout,
};

export default DEFAULT_CONTENT;
